import { addQueryParams, useRouter } from '@main/core-ui';
import { selectActiveDataSubject } from '@main/privacy-center/src/containers/ActiveDataSubject/selectors';
import { setOAuthState } from '@main/privacy-center/src/containers/TokenLogin/slice';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { writeOauthStateToLocalStorage } from '../TokenLogin/helpers';
import { useAuthorizationUrl } from './generateAuthorizationUrl';
import { loginMessages } from './messages';
import { LinkWrapper } from './wrappers';

/**
 * Privacy Center log in button
 */
export const Login: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { redirect, location } = useRouter();
  const dispatch = useDispatch();
  const activeDataSubject = useSelector(selectActiveDataSubject);
  const loginRedirect = useAuthorizationUrl(activeDataSubject);

  const handleRedirect: () => void = () => {
    if (loginRedirect) {
      if (loginRedirect.state) {
        dispatch(
          setOAuthState({
            oAuthState: loginRedirect.state,
          }),
        );
      }

      writeOauthStateToLocalStorage(loginRedirect.state);
      window.location.href = loginRedirect.url.href;
    } else {
      redirect(addQueryParams(location, { modal: 'log-in' }));
    }
  };

  return (
    <LinkWrapper
      message={loginMessages.logIn}
      tabIndex={0}
      role="link"
      onClick={handleRedirect}
      onKeyUp={(event) => event.key === 'Enter' && handleRedirect()}
      type="primary"
    />
  );
};

export default Login;
